import { useCallback, useMemo } from 'react'
import { useQueries, useQuery } from '@tanstack/react-query'
import { sampleTeamWithCatalog, templateSampleTeamId } from './prepackCardModel'
import { templatePreviewTeamQuery, templateTeamsQuery } from './templatePreviewQueries'

const NO_TEAMS = new Map()

/**
 * The sample teams the Templates gallery draws its cards with (#1121): one dressed team per catalog id the saved
 * templates name (templateSampleTeamId), read through the template builder's own queries so a team the builder
 * showed is already here when the operator comes back from Save. Returns Map<teamId, team | undefined>: the
 * server's dressed team, the catalog entry while it loads or after it failed, undefined (the Eagles) otherwise.
 */
export function useTemplateSampleTeams(orgSlug, templates) {
  const teamIds = useMemo(() => [...new Set((templates || []).map(templateSampleTeamId).filter(Boolean))], [templates])
  const teamsQuery = useQuery({ ...templateTeamsQuery(orgSlug), enabled: Boolean(orgSlug) && teamIds.length > 0 })
  const catalog = teamsQuery.data
  const combine = useCallback((results) => {
    if (!teamIds.length) return NO_TEAMS
    return new Map(results.map((result, index) => {
      const id = teamIds[index]
      const entry = catalog?.find((team) => team.id === id)
      return [id, sampleTeamWithCatalog(result.data?.team, entry)]
    }))
  }, [teamIds, catalog])
  return useQueries({ queries: teamIds.map((id) => templatePreviewTeamQuery(orgSlug, id)), combine })
}
